import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateD: SceneTemplate = {
    name: "תבנית ד",
    aspectRatio: "16:9",
    branding: {
        background: "primary",
        foreground: {
            color: "secondary",
            circle: true,
            size: {
                width: 134,
                height: 134,
            },
            location: {
                x: 53.5,
                y: -19,
            },
        },
    },
    avatar: {
        size: {
            width: 33,
            height: 73,
        },
        location: {
            x: 67,
            y: 27,
        },
    },
    scene: {
        scale: 60,
        rounded: true,
        location: {
            x: 3.5,
            y: 20,
        },
    },
};
